import React, { FC } from 'react';

export interface IDomainProgressBarProps {
  label?: string;
  isMax?: boolean;
  value: number;
}

export const DomainProgressBar: FC<IDomainProgressBarProps> = ({ label, isMax, value }) => {
  const valueSet = !!label;
  // if value is set we draw 2px line for value===0
  const barValue = valueSet ? Math.max(2, value) : value;
  const barHeight = Math.ceil((96 * barValue) / 100);
  const barYPos = 136 - barHeight;
  return (
    <>
      <rect x="0" y="0" width="64" height="1" className="border" />
      {isMax ? (
        <path
          className="star"
          d="M12 0L15.174 7.63131L23.4127 8.2918L17.1357 13.6687L19.0534 21.7082L12 17.4L4.94658 21.7082L6.86429 13.6687L0.587322 8.2918L8.82596 7.63131L12 0Z"
        />
      ) : null}
      <rect x="8" y={barYPos} width="48" height={barHeight} className="bar" />
      <rect x="0" y="136" width="64" height="1" className="border" />
      {label ? (
        <text x="32" y="150" className="label">
          {label}
        </text>
      ) : null}
    </>
  );
};

export default DomainProgressBar;
